import { get } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetVideosBySearchInterface {
  status: string;
  searchKeyword: string;
}

export const useGetVideosBySearch = () => {
  const mutate = useMutation(({ status, searchKeyword }: GetVideosBySearchInterface) => {
    return get(`/media-api/search_videos_by_tittle/${status}/${searchKeyword}`);
  });

  return mutate;
};

export default useGetVideosBySearch;
